/**
 * Bitter Winter App Topics
 * @author: Carl
 * @date: 11/22/2018
 * @version 1.0.0
 */

class BitterWinterApp {
  constructor () {
    this.breakPoints = {
      pc: 1188,
      tablet: 768,
      mobile: 0
    }
    
    this.init()
  }
  
  init () {
    //  image slick handle
    this._imageSlickHandle()
    //  content slick handle
    this._contentSlickHandle()
    //  features slick handle
    this._featuresSlickInit()
    this._featuresSlickMobileHandle()
    this._featuresSlickHandle()
    //  section bg load handle
    this._sectionBgLoadHandle()
    //  scroll reveal animate handle
    this._scrollRevealAnimateHandle()
    //  handle share box
    this._handleShareBox()
  }
  
  /**
   * handle share box
   * @private
   */
  _handleShareBox () {
    let sAction = document.getElementById('shareBoxTemplate').innerHTML
  
    $('.downloadApp__Action').html(sAction)
  
    let oP = $('.downloadApp__Action>p').eq(0).clone()
    $('.downloadApp__Action>p').remove()
    $('.downloadApp__Action').parent().prepend(oP.clone())
  }
  
  /**
   * scroll reveal animate handle
   * @private
   */
  _scrollRevealAnimateHandle () {
    const oSR = window.ScrollReveal({
      reset: false,
      origin: 'bottom',
      duration: 1000,
      delay: 0,
      scale: 1,
      easing: 'ease-in-out',
      mobile: false,
      distance: '40px',
    })
    
    oSR.reveal('.iphone', {delay: 100})
    oSR.reveal('.content-center', {delay: 0})
    
    oSR.reveal('.wrapper__section--three>.section-wrapper>h1', {delay: 0})
    oSR.reveal('.wrapper__section--three>.section-wrapper>p', {delay: 200})
    oSR.reveal('.wrapper__section--three>.section-wrapper>.contentSlick', {delay: 400})
    
    oSR.reveal('.wrapper__section--four>.section-wrapper>h1', {delay: 0})
    oSR.reveal('.wrapper__section--four>.section-wrapper>p', {delay: 200})
    oSR.reveal('.wrapper__section--four .features__box', {delay: 400})
    
    oSR.reveal('.wrapper__section--five>.section-wrapper>h1', {delay: 0})
    oSR.reveal('.wrapper__section--five>.section-wrapper .downloadApp', {delay: 200})
  }
  
  /**
   * section bg load handle
   * @private
   */
  _sectionBgLoadHandle () {
    $('.coverBg').map((k, el) => {
      let randomString = this.randomString()
      let innerWidth = window.innerWidth
      let bgImg = ''
      let oBg = {
        pc: el.dataset.coverBgPc,
        tablet: el.dataset.coverBgTablet,
        mobile: el.dataset.coverBgMobile
      }
      
      //  check breakpoints
      if (innerWidth >= this.breakPoints.pc) {
        bgImg = oBg.pc
      } else if (innerWidth >= this.breakPoints.tablet) {
        bgImg = oBg.tablet
      } else {
        bgImg = oBg.mobile
      }
      
      //  set class
      el.classList.add(randomString)
      
      //  render img
      this.renderImgTag(bgImg).then(img => {
        this.__setCoverBgStyle(oBg, randomString)
        el.classList.add('coverBgLoaded')
      })
    })
  }
  
  /**
   * set cover bg style
   * @param oBg
   * @param randomString
   * @private
   */
  __setCoverBgStyle (oBg, randomString) {
    this.writeStyle(`${randomString}Style`, `
     @media(min-width: ${this.breakPoints.mobile}px){.${randomString}::after{background-image: url('${oBg.mobile}')}}
     @media(min-width: ${this.breakPoints.tablet}px){.${randomString}::after{background-image: url('${oBg.tablet}')}}
     @media(min-width: ${this.breakPoints.pc}px){.${randomString}::after{background-image: url('${oBg.pc}')}}
    `)
  }
  
  /**
   * features slick handle
   * @private
   */
  _featuresSlickHandle () {
    const oSlick = $('.features .iphone .featuresSlick')
    
    //  slick handle
    oSlick.slick({
      swipe: true,
      fade: true,
      dots: false,
      waitForAnimate: false, //  不等待animate执行结束
      arrows: false,
      pauseOnDotsHover: true,
      infinite: true,
      slidesToShow: 1,
      cssEase: 'ease-out',
      slidesToScroll: 1,
      adaptiveHeight: false,//  自动高度取消
      autoplay: true,
      autoplaySpeed: 4000,
    })
    .on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      $('.features .features__item').removeClass('active')
      $(`.features .features__item[data-index="${nextSlide}"]`).addClass('active')
    })
    
    //  click change event handle
    $('.features .features__item').click(ev => {
      let oTarget = ev.currentTarget
      let iIndex = oTarget.dataset.index
      
      oSlick.slick('slickGoTo', iIndex)
    })
    
  }
  
  _featuresSlickInit () {
    const iconsArr = ['icon-search', 'icon-access_time', 'icon-mail', 'icon-message', 'icon-thumb_up', 'icon-language'];
    let oItems = $('.features__box--left .features__item')
    oItems.map((k, el) => $(el).prepend(`<button><i class="${iconsArr[k]}"></i></button>`))
    
    $('.features__box--right').append(oItems.slice(3, 6))
  }
  
  _featuresSlickMobileHandle () {
    let oDiv = $('<div class="featuresMobile" />')
    oDiv.append($('.features .iphone').clone())
    oDiv.append($('<div class="featuresMobileItemsBox" />'))
    $('.features').after(oDiv)
    
    let oBox = $('.featuresMobileItemsBox')
    $('.features__item').map((k, el) => oBox.append($(el).clone()))
    
    //   call slick
    const oSlick = $('.featuresMobile .iphone .featuresSlick')
    const oItems = $('.featuresMobile .featuresMobileItemsBox')
    //  slick handle
    oSlick.slick({
      swipe: true,
      fade: true,
      dots: false,
      waitForAnimate: false, //  不等待animate执行结束
      arrows: true,
      pauseOnDotsHover: true,
      infinite: true,
      slidesToShow: 1,
      cssEase: 'ease-out',
      slidesToScroll: 1,
      adaptiveHeight: false,//  自动高度取消
      autoplay: true,
      autoplaySpeed: 4000,
      asNavFor: '.featuresMobileItemsBox',
      prevArrow: '<button type="button" class="slick-prev slickArrow"><i class="icon-arrow_left"></i></button>',
      nextArrow: '<button type="button" class="slick-next slickArrow"><i class="icon-arrow_right"></i></button>'
    })
    
    oItems.slick({
      swipe: false,
      fade: true,
      dots: true,
      arrows: false,
      slidesToShow: 1,
      cssEase: 'ease-out',
      slidesToScroll: 1,
      adaptiveHeight: true,//  自动高度取消
      asNavFor: '.featuresMobile .featuresSlick',
    })
  }
  
  /**
   * content slick handle
   * @private
   */
  _contentSlickHandle () {
    //  clone mobile slick
    let oDiv = $('<div class="contentSlickMobile" />')
    oDiv.html($('.contentSlick').html())
    $('.contentSlick').after(oDiv)
    
    $('.contentSlick').slick({
      slidesToShow: 3,
      variableWidth: true,
      slidesToScroll: 1,
      swipe: true,
      dots: false,
      waitForAnimate: false, //  不等待animate执行结束
      arrows: true,
      infinite: true,
      cssEase: 'ease-out',
      adaptiveHeight: false,//  自动高度取消
      centerMode: true,
      focusOnSelect: true,
      centerPadding: 0,
      prevArrow: '<button type="button" class="slick-prev slickArrow"><i class="icon-arrow_left"></i></button>',
      nextArrow: '<button type="button" class="slick-next slickArrow"><i class="icon-arrow_right"></i></button>',
    })
  }
  
  /**
   * image slick handle
   * @private
   */
  _imageSlickHandle () {
    $('.imageSlick').slick({
      swipe: true,
      fade: true,
      dots: false,
      waitForAnimate: false, //  不等待animate执行结束
      arrows: false,
      pauseOnDotsHover: true,
      infinite: true,
      slidesToShow: 1,
      cssEase: 'ease-out',
      slidesToScroll: 1,
      adaptiveHeight: false,//  自动高度取消
      autoplay: true,
      autoplaySpeed: 4000,
    })
  }
  
  /**
   * render Image
   * @param url
   * @returns {Promise<any>}
   */
  renderImgTag (url) {
    return new Promise((res, rej) => {
      if (url) {
        let img = new Image()
        
        img.onload = () => {
          res(img)
        }
        
        img.onerror = () => {
          rej(new Error(`Could not load image at ${url}`))
        }
        
        img.src = url
      }
    })
  }
  
  /**
   * write style inside head
   * @param styleClass
   * @param content
   */
  writeStyle (styleClass, content) {
    if ($(`.${styleClass}`).length === 0) {
      let oStyleEl = $(`<style class="${styleClass}" />`)
      $('head').append(oStyleEl)
    }
    
    let oStyle = $(`.${styleClass}`).eq(0)
    oStyle.html(content)
  }
  
  /**
   * get random string
   * @returns {string}
   */
  randomString () {
    let text = '';
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    
    for (let i = 0 ; i < 5 ; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    
    return 'random' + text
  }
}

export default BitterWinterApp
